// Buyer lead capture is OR-gated by a build-time constant against the debug-panel
// toggle (`epoLeadsCaptureBuyer`), mirroring the FPS flag. The debug toggle is
// persisted per-browser in localStorage (`max-debug-storage`), so flipping the
// store's default from `false` to `true` does NOT enable the feature for users
// who already have `false` rehydrated from their cache. Setting this build-time
// constant `true` launches lead capture for everyone regardless of that stale
// cache — the runtime dual-gate on an AIPOS `leadCampaignId` still limits it to
// allowlisted products.
export const BUILD_TIME_LEADS_CAPTURE_ENABLED = true;

// Single expression (kept on one line, like fpsFeatureFlag) so its coverage is a
// single line satisfied by any call — a split body's right operand never executes
// while the build-time constant is `true` (short-circuit) and reads as uncovered.
export const isLeadsCaptureEnabledBuyer = (debugToggle: boolean): boolean => BUILD_TIME_LEADS_CAPTURE_ENABLED || debugToggle;
